module.exports = __webpack_public_path__ + "static/media/logo.e13bfb62.png";